module.exports = __webpack_public_path__ + "img/bespoke123_24.02871254.jpg";